var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9277 15.9507C87.8651 15.9651 87.802 15.9799 87.7383 15.9953C79.8677 17.9839 73.406 36.2238 71.1449 45.1651C68.6585 57.5968 75.8258 71.9229 77.0499 76.8659C77.9669 80.569 77.8333 88.6338 74.377 94.2208C71.5613 98.7724 61.4067 103.18 55.9161 104.526C57.9051 100.797 57.9881 95.3063 57.7809 93.0271C56.8484 88.3652 54.0513 86.5005 51.2542 85.8789C46.7788 84.8844 41.1931 82.2348 40.0657 80.5954C38.9384 78.9561 39.3292 78.3852 39.5958 77.3886C39.5958 77.3886 39.5958 77.3886 39.5958 77.3885L39.8991 76.6808C41.1126 74.4055 43.4845 74.0688 44.4168 72.5149C44.7276 71.8933 44.3132 70.6501 44.106 70.0285C43.9646 69.6043 43.5881 68.2674 43.1737 67.5422C42.6764 66.7963 42.5521 65.9882 43.1737 65.6774C43.9387 65.3498 45.4735 64.9937 44.7276 64.745C43.7952 64.4343 42.3547 62.3489 44.106 61.6371C45.6354 61.0155 47.4212 59.4616 48.1463 58.5292C48.7421 57.6138 48.7926 55.4397 47.8355 54.4889C46.807 53.4672 45.66 51.6918 45.3492 50.7594C44.7857 49.0688 45.5061 48.5127 46.0117 48.007C46.6185 47.4003 51.8758 44.958 54.673 43.922C56.8485 43.3004 62.5455 40.4733 63.0644 37.7061C64.4053 27.111 80.0037 17.864 87.7383 15.9953C87.8014 15.9794 87.8645 15.9645 87.9277 15.9507Z",
    fill: "url(#paint0_linear_18_171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0017 8.52179C71.3504 0.956774 48.2225 5.41401 32.8013 21.617C14.4111 40.9396 13.246 70.3832 28.8372 90.982C15.214 78.0762 9.33256 58.0675 15.3612 38.9695C23.7756 12.3135 52.9794 -5.29583 79.6354 3.11862C83.7351 4.41275 87.5357 6.24707 91.0017 8.52179Z",
    fill: "url(#paint1_linear_18_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_171",
    x1: 30.4858,
    y1: -0.404256,
    x2: 137.85,
    y2: 59.6466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215334,
    stopColor: "#D7A799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313209,
    stopColor: "#D3927A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397866,
    stopColor: "#CF7D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60157,
    stopColor: "#736261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844303,
    stopColor: "#2D414F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92A5A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_171",
    x1: 42.636,
    y1: -16.3856,
    x2: 42.2409,
    y2: 100.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    stopColor: "#C4E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9898,
    stopColor: "#A4BCBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.006582f012953de54ec2d2dab2de03ca.svg";
export { ForwardRef as ReactComponent };